var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"page-header w-full h-14 flex items-center justify-between px-3 bg-white rounded"},[_c('div',{staticClass:"panel-left flex"},[_vm._t("brand"),_vm._t("path")],2),_c('div',{staticClass:"flex"},[_vm._t("actions")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }